import {Component, OnInit} from '@angular/core';
import {SideNavService} from '../services/sidenav.service';
import {ReferenceEntity, Role, User} from '../models';
import {FORM_TYPE, USER_TYPES} from '../enums';
import {NgxSpinnerService} from 'ngx-spinner';
import {MainService} from '../services/main.service';
import {toggleHideById,passwordValidation} from '../utils';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DataService} from '../services/data.service';
import {AuthService} from '../authentication/auth.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  // imported methods reassigned for view
  toggleHideById = toggleHideById;

  users: User[] = [];
  usersFiltered: User[] = [];
  p = 1;
  pageSize = 10;
  dropdownSettings = {};
  dropdownSettingsforref = {};
  selectedUserTypes = [];
  formType;
  isSubmitted = false;
  isDataFetched = false;
  form;
  error;
  selectedUserId;
  selectedUserName;
  selectedUserMail;
  roles: Role[];
  rolesForRef: Role[];
  userReferenceALL: ReferenceEntity[] = [];
  searchTerm = '';
  currentSelectedUserId;
  hostUrl = '';
  selectedRoleId = null;
  references = [];
  isAdvanceOption = false;
  lookup = []
  isResetPassword=false
  resetForm
  userId
  protectData
  currentUserRole


  constructor(private sideNavService: SideNavService, private spinner: NgxSpinnerService,
              private mainService: MainService, private toaster: ToastrService, private formBuilder: FormBuilder,
              private dataService: DataService, private AuthService:AuthService) {
  }

  ngOnInit() {
    this.getUsers();
    this.getRoles();

    this.dropdownSettings = this.dropdownSettings = {
      singleSelection: false,
      search: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };

    this.dropdownSettingsforref = {
      singleSelection: false,
      search: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };


    this.form = this.formBuilder.group({
      lastName: [null, [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z_ ]*')]],
      email: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/)]],
      mobile: [null, [Validators.required, Validators.pattern(/^(?:\+|0)[1-9]\d{6,14}$/)]],
      whatsApp: [null, [Validators.required, Validators.pattern(/^(?:\+|0)[1-9]\d{6,14}$/)]],
      userRoleId: [[], [Validators.required]],
      userreferences: [[], [Validators.required]],
      username: [[], [Validators.required]],
      password: [null,[passwordValidation]],
      confirmPassword: [null, [Validators.required]]
    }, {
      validators: this.passwordMatchValidator
    });


    this.resetForm = this.formBuilder.group({
      password:[null,[passwordValidation]],
      confirmPassword:[null,[Validators.required]]
    },{
      validators: this.passwordMatchValidator
    });
    this.getMetaData();
    this.getCurrentUser();
    this.currentUserRole = localStorage.getItem('ROLE')
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  passwordMatchValidator(form: FormGroup) {
    const passwordValue = form.get('password').value;
    const confirmPasswordValue = form.get('confirmPassword').value;

    if (passwordValue !== confirmPasswordValue) {
      form.get('confirmPassword').setErrors({passwordMatchError: true})
    }
    return null;
  }

  onChanges(val) {
    this.selectedRoleId = val.target.value;
    // tslint:disable-next-line:triple-equals
    if (this.selectedRoleId < 10) {
      this.form.controls.userreferences.setValue([]);
      this.form.get('userreferences').clearValidators();
    } else {
      this.form.get('userreferences').setValidators([Validators.required]);
    }
    this.form.get('userreferences').updateValueAndValidity();
    if (this.selectedRoleId != null && this.selectedRoleId >= 10) {
      this.mainService.getReferencesForRole(this.selectedRoleId).subscribe(res => {
          this.userReferenceALL = res.content;
          // this.referencesStr = this.references.map(ref => ref.name);
          this.spinner.hide();
        }, (error) => {

          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    }
  }

  getMetaData() {
    this.mainService.getMetaData()
      .subscribe(response => {
        this.hostUrl = response.content.configuration.configHost;
        this.dataService.updateData(response.content.configuration.configHost);
        console.log(this.hostUrl)
      }, error => {
      }, () => {
      });
  }

  getUsers() {
    this.spinner.show();
    this.mainService.getUsers()
      .subscribe(response => {
        this.users = response.content;
        this.usersFiltered = response.content;
        this.isDataFetched = true;
      }, error => {
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      });
  }

  getRoles() {
    this.spinner.show();
    const filterRole: string[] = ['super'];
    this.mainService.getRoles()
      .subscribe(response => {
        this.roles = response.content;
        this.rolesForRef = response.content.filter(word => !filterRole.includes(word.name));

        this.rolesForRef.sort((a, b) => Number(a.id) - Number(b.id));
      }, error => {
        this.spinner.hide();
      }, () => {
        // this.spinner.hide();
      });
  }

  resetPassword(entity: any) {
    this.isSubmitted = true;
    if (!this.resetForm.valid) {
      return;
    }
    this.spinner.show()
    fetch(
      `${environment.host}/ums/${this.getCurrentUser()}/password?id=${this.userId}&password=${entity.password}`,
      {
          method: "PUT",
          headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + AuthService.getAccessToken()}
      })
      .then((res)=>{
        console.log(res)
        toggleHideById('login-section');
        this.resetForm.reset()
        this.toaster.success('Password changed successfully.')
        this.spinner.hide()
      }).catch((error)=>{
        this.toaster.error('Oops... Something went wrong', 'Error!');
        this.spinner.hide()
      })
  }

  hideResetPassword(){
    toggleHideById('login-section')
    this.error=false
    this.resetForm.reset()
  }

  getRoleName(roleId) {
    if (!this.roles) {
      return roleId;
    }
    const role = this.roles.find(e => e.id === roleId);
    // console.log(role.name)
    return role ? role.name : "";
  }

  getCurrentUser(){
    return localStorage.getItem('USER_ID')
  }

  getTypeName(roleId) {
    return USER_TYPES[roleId];
  }

  getUserTypes(): string[] {
    if (!this.roles) {
      return [];
    }

    this.roles.forEach(obj => {
      this.lookup.push({item_id: obj.id, item_text: obj.name});
    });
    return this.lookup;
  }


  filterUsers() {
    const selTypes = [];
    this.selectedUserTypes.forEach(obj => selTypes.push(parseInt(obj.item_id, 10)));
    if (selTypes.length === 0) {
      this.clearAllFilters();
      return;
    }
    this.usersFiltered = this.users.filter(user => {
      return selTypes.includes(user.userRoleId);
    });
  }

  clearAllFilters() {
    this.usersFiltered = this.users;
  }

  resetPasswordClick(user){
    this.userId = user.id
    this.isSubmitted = false
    toggleHideById('login-section')
    this.isResetPassword = true
    console.log(this.isResetPassword)
  }

  emailChanges() {
    this.error = null;
  }

  addUserInit() {
    this.formType = FORM_TYPE.ADD;
    this.isSubmitted = false;
    this.form.reset();
    this.error = null;
    toggleHideById('addNew');
  }

  editUserInit(user) {
    this.formType = FORM_TYPE.EDIT;
    this.isSubmitted = false;
    this.error = null;
    this.form.reset();
    const userToPatch = JSON.parse(JSON.stringify(user));
    this.form.patchValue(userToPatch);
    toggleHideById('addNew');
  }

  createUser(value) {
    this.isSubmitted = true;

    if (this.form.controls.lastName.invalid ||
      this.form.controls.email.invalid ||
      this.form.controls.mobile.invalid ||
      this.form.controls.whatsApp.invalid ||
      this.form.controls.userRoleId.invalid ||
      (this.selectedRoleId != null && this.selectedRoleId >= 10 && this.form.controls.userreferences.invalid)) {
      return;
    }
    if (!this.form.valid && this.isAdvanceOption) {
      return;
    }
    this.spinner.show();
    if (this.formType === FORM_TYPE.ADD) {
      // tslint:disable-next-line:triple-equals
      if (value.userRoleId >= 10) {
        this.references = [];
        this.references.push(value.userreferences);
        value.references = this.references;
      }
      this.dataService.share.subscribe(host => this.hostUrl = host);
      value.host = this.hostUrl;
      this.mainService.createUser(value).subscribe(response => {
        this.toaster.success('User Created Successfully!');
        toggleHideById('addNew');
        this.getUsers();
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      }, () => {
        this.selectedRoleId = null;
        this.references = [];
        this.spinner.hide();
      });
    } else {
      this.mainService.updateUser(value).subscribe(response => {
        this.toaster.success('User Updated Successfully!');
        toggleHideById('addNew');
        this.getUsers();
        this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
          this.toaster.error('Something Went Wrong!');
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
    }
  }

  deleteUser() {
    this.spinner.show();
    this.mainService.deleteUser(this.selectedUserId).subscribe(() => {
      this.toaster.success('User \"' + this.selectedUserName + '\" has been deleted successfully!');
      this.spinner.hide();
    }, (error) => {
      if (error.status === 422) {
        this.toaster.error(error.error.message, 'Error!');
      } else {
        this.toaster.error('Oops... Something went wrong', 'Error!');
      }
      this.spinner.hide();
    }, () => {
      this.getUsers();
      this.spinner.hide();
    });
    toggleHideById('deleteUser');
  }

  getUsersFiltered() {
    return this.usersFiltered.filter(u => JSON.stringify(Object.values(u)).toLowerCase().includes(this.searchTerm.trim().toLowerCase()));
  }

//   resendRegistrationMail() {
//     toggleHideById('resendRegistrationMail');
//
//     console.log(this.selectedUserEmail);
//   }
// }


  resendRegistrationMail() {
    const selectedUser = this.users.find(item => {
      return item.id === this.currentSelectedUserId;
    });
    this.spinner.show();
    this.dataService.share.subscribe(host => this.hostUrl = host);
    this.mainService.resendRegistrationMail({
      host: this.hostUrl,
      email: selectedUser.email,
      mobile: selectedUser.mobile,
    }).subscribe(response => {
      this.spinner.hide();
      toggleHideById('resendRegistrationMail');
      this.toaster.success('A mail has been sent again. Please confirm within 24 hours', 'Success');
    }, error => {
      this.spinner.hide();
      if (error && error.status === 422) {
        this.error = error.error.message;
      } else {
        this.toaster.error('Oops... Something went wrong', 'Error!');
      }
    });
  }

  resetMail() {
    const selectedUser = this.users.find(item => {
      return item.id === this.currentSelectedUserId;
    });
    this.spinner.show();
    this.dataService.share.subscribe(host => this.hostUrl = host.replace('sign-up', 'reset'));

    this.mainService.resetMail({
      host: this.hostUrl,
      email: selectedUser.email,
      // mobile: selectedUser.mobile,
    }).subscribe(response => {
      // this.spinner.hide();
      console.log(response)
      this.toaster.success(response.message)
      // toggleHideById('resendRegistrationMail');
      // this.toaster.success('A mail has been sent again. Please confirm within 24 hours', 'Success');
    }, error => {
      this.spinner.hide();
      if (error && error.status === 422) {
        this.error = error.error.message;
        this.toaster.error(error.error.message)
        console.log(this.error)
      } else {
        this.toaster.error('Oops... Something went wrong', 'Error!');
      }
    }, () => {
      this.spinner.hide();
    });
    console.log(this.hostUrl)
  }

  isSuperAdmin() {
    return AuthService.isSuperAdmin();
  }

  isProtect(){

  }

  protectUserData(id,isProtect){
    // let protectIcon = document.getElementById("protect"+index) as HTMLElement
    this.spinner.show()
    if(this.currentUserRole == 1 || isProtect == true){
      fetch(
        environment.host + '/ums/'+ this.getCurrentUser()+'/user-protect/' + id+ '?isProtect=' + isProtect,
        {
          method: "PUT",
          headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + AuthService.getAccessToken()}}
      ).then((res)=>res.json())
      .then(data=>{
        this.getUsers()
        // this.spinner.hide()
      })
    }else{
      this.spinner.hide()
      this.toaster.error("You Can't Unlock the Data.")
    }



  }



  // protectUser(userId,isProtect){
  //   return this.http.put<MagmaResponse<any>>(
  //     environment.host + '/ums/user-protect/' + userId + '?isProtect=' + isProtect,
  //     {
  //       headers: new HttpHeaders(
  //         {
  //           'Content-Type': 'application/json',
  //           Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
  //         })
  //     }
  //   )
  // }
}
